//Stateler çekilip return edilecek

export const getLDAPLoading = (state) => {
  return state.loading
}

export const getADAttributes = (state) => {
  return state.attributes
}

export const getLDAPStatus = (state) => {
  return state.status
}

export const getADFilters = (state) => {
  return state.filters
}

export const getLDAPData = (state) => {
  return state.LDAPData
}

export const getLDAPFilter = (state) => {
  return state.LDAPFilter
}

export const getADFields = (state) => {
  return state.ADFields
}


// WEBPACK FOOTER //
// ./src/store/modules/LDAP/Getters.js